import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "proptypes";

import { scroller } from "ux-helpers";
import logo from "../../../assets/give-logo-white.png";
import menuIcon from "../../../assets/menu-icon.png";
import "./Header.scss";

const Header = ({ toggleSideBar, onLogout, pathname }) => {
  const loggedIn = window.localStorage.sessionToken ? (
    <button className="logout default-btn" onClick={onLogout}>
      <strong>Logout</strong>
    </button>
  ) : (
    <button
      className="login default-btn"
      onClick={() => {
        if (pathname === "/") {
          scroller("login-form");
        }
      }}
    >
      <strong>Login</strong>
    </button>
  );

  return (
    <div className="header static-header">
      <div className="flex-child">
        <button
          className="topnav-menu-light default-btn"
          onClick={toggleSideBar}
        >
          <img className="menu-icon" src={menuIcon} alt="menu" />
          <strong>Menu</strong>
        </button>
      </div>
      <div className="flex-child">
        <a href="https://www.givevolunteers.org">
          <img className="logo" src={logo} alt="GIVE logo" />
        </a>
      </div>
      <div className="flex-child">
        <Link to="/">{loggedIn}</Link>
      </div>
    </div>
  );
};

Header.propTypes = {
  pathname: PropTypes.string.isRequired,
  onLogout: PropTypes.func.isRequired,
  toggleSideBar: PropTypes.func.isRequired
};

export default Header;
